import { useMemo } from "react";
import {
  IncidentTableData,
  UseIncidentTablePaginationParams,
} from "../../types";

const paginateRows = (
  rows: Array<IncidentTableData>,
  page: number,
  rowsPerPage: number,
): Array<IncidentTableData> => {
  const firstRowIndex = page * rowsPerPage;
  return rows.slice(firstRowIndex, firstRowIndex + rowsPerPage);
};

export function useIncidentTablePagination({
  rows,
  page,
  rowsPerPage,
}: UseIncidentTablePaginationParams) {
  return useMemo(() => {
    return paginateRows(rows, page, rowsPerPage);
  }, [rows, page, rowsPerPage]);
}
